import { CloseRounded as  Edit,  Delete, Search } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Button, Card, CardContent, GridLegacy as Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import {   AutoCompleteInputWithLabel, InputFile,  InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance,  CapitalizeFirstLetter,  DialogType,  FormActions,getUrlImage } from "../../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../../components/form/ModalForm";




const ComposicionesYupValidation = yup.object({
  producto:yup.object({
    label:yup.string(),
    value:yup.number()
}).test("is_selected",(value,ctx)=>{
   
   if(  !value.value  ){
    return  ctx.createError({ message: 'Seleccione un producto' })
   }
   
    return true;
}),
calidad:yup.string().required(),
});



const schema = yup.object({
  nombre_producto:yup.string().required(),
  categoria: yup.string().required(),
  composiciones: yup.array(ComposicionesYupValidation),
  estado: yup.string().optional().notRequired(),
  
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

const EstadosItemVenta = [
  "HABILITADO",
  "DESHABILITADO"
];


const ProductoListItem  = ({
  onDeleteIcon,
  producto,
  calidad,



})=>{

  return (<Card sx={{width:'100%',marginBottom:'5px'}} >
      
    <CardContent>
      
      <Grid container >
        <Grid item sx={10} md={10} >
          <Typography variant="p" ><strong>ITEM:</strong>:{producto?.label}</Typography> <br/>
          <Typography variant="p" > <strong>CALIDAD O PRESENTACION:</strong> {calidad} </Typography>
        </Grid>
        <Grid item sx={2} md={2} >
            <IconButton onClick={onDeleteIcon} sx={{background:"red",color:"white"}}   >
              <Delete  />
            </IconButton>
        </Grid>
      </Grid>
        
    </CardContent>
  </Card>)

}

export const MaestroProductosVentas = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [productosOptions,setProductosOptions] = useState([]);
  const [categoriasOptions,setCategoriasOptions] = useState([]);



    useEffect(()=>{

      
      loadInitData();
      loadCategories();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);

    const loadCategories = async(evt,value)=>{
      const {data:{value:{data}}}  = await AxiosInstance.post("maestros-marketplace/obtener-categorias",{search:value,rows_per_page:100,page_number:1});

      setCategoriasOptions(data.map(item=>({label:item.descripcion,value:item.cod})));
   }


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
    
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post(`maestros-marketplace/get-productos-ventas/${profile.cod_cia || ''}`,{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });

     setDataSetProductos([...value.data]);
     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };



    const onShowDetailProduct = (product)=>{
      setIsVisibleModalDetalle(true);
/*       composiciones.map(item=>({
        calidad:CapitalizeFirstLetter(item.calidad),
        producto_cod:item.producto.value,
        producto_nom:item.producto.label
    }))} */
     
      setProductoSeleccionado({
        ...product,
        categoria:product.categoria_value,
        composiciones:product.composiciones.map(item=>({
          calidad:item.calidad_vta,
          producto:{
            label:item.label,
            value:item.value
          }
        })),
       
      });
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);

    }

    const onOpenModalItem = (edit=false)=>{
      console.log({edit});
      if (!edit){
        setProductoSeleccionado({});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{

      let payload =  {...dataForm,
        beforeInfo:{...productoSeleccionado},
        composiciones:dataForm.composiciones.map(item=>({
        calidad:CapitalizeFirstLetter(item.calidad),
        producto_cod:item.producto.value,
        producto_nom:item.producto.label
    }))};

        const urlService = 'maestros-marketplace/activar-producto-venta';

        payload.estado =  typeAction === FormActions.AGREGAR?'HABILITADO':dataForm.estado;
        console.log({payload});

        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }



    const columnsTable = [
      {
      
       key:"nombre_producto",
       keyValue:"nombre_producto",
       label:"Nombre del producto",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
    
      {
      
        key:"categoria_label",
        keyValue:"categoria_label",
        label:"Categoria",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"estado",
        keyValue:"estado",
        label:"Estado",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     
      
      {
        key:"editar",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value,info})=><Button onClick={e=>onShowDetailProduct(info)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
    ];


    const searchProductFilter = async(evt,value)=>{
       try{
        if ( value.length > 0 ){
          const {data:{value:data_res}}  = await AxiosInstance.post(`maestros/get-producto-filter`,{search_query:value})
          setProductosOptions(data_res);
        }
        
       }catch(e){

       }
    }

   const onSearchItem = (evt)=>{
    if ( evt.target.value.length > 3 && evt.target.value.length % 2 ){
      setFilterSearchPagination({...filterSearchPagination,search_query: evt.target.value});
    }
   }
   
    const configModal =  {
      titleModal: tipoAction === FormActions.AGREGAR? "Agregar  Producto":'Modificar Producto',
      buttomsAction: tipoAction === FormActions.AGREGAR? [
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              onClick:()=>setIsVisibleModalDetalle(false),
              color:"secondary"
          }
          },
          {
            title:"Registrar",
            buttomProps:{ 
              type:"submit",
             // onClick:onSaveDataNewData
            }
          }
      ]:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key: "nombre_producto",
          keyValue: "nombre_producto",
          label: "Nombre comun del producto",
          component: InputWithLabel,
          inputProps: {
            //disabled:FormActions.MODIFICAR == tipoAction,
            name: 'nombre_producto',
            fullWidth: true,
            size:"small",
            
          }
        },
        {
          key: "url_imagen",
          keyValue: "url_imagen",
          label: "Imagen del producto",
          component: InputFile,
          inputProps: {
            disabled:FormActions.MODIFICAR == tipoAction,
            name: 'url_imagen',
            fullWidth: true,
            size:"small",
            
          }
        },
       {
          key: "categoria",
          keyValue: "categoria",
          label: "Categoria",
          component: SelectInputWithLabel,
          inputProps: {
            size:"small",
            type:"text",
            items:categoriasOptions || []
          }
        },
 
        
        {
          key:"estado",
          keyValue:"estado",
          label:"Estado",
          component:SelectInputWithLabel,
          items:1,
          inputProps:{
            size:"small",
            disabled: tipoAction === FormActions.AGREGAR,
            type:"text",
            items:EstadosItemVenta.map(item=>({label:item,value:item}))
          }
        },
        
 ],
 arrayInputs:[
  {
    label:"Items de composicion",
    key:"composiciones",
    keyValue:"composiciones",
    subSchema:ComposicionesYupValidation,
    ItemRender:ProductoListItem,
    inputs:[

      {
        key:"producto",
        keyValue:"producto",
        label:"Producto o item",
        component: AutoCompleteInputWithLabel,
        responsiveSize:6,
        inputProps: {
          typeInput:"autoComplete",
          size:"small",
          name: 'producto',
          fullWidth: true,
          isLoading: false,
          onInputChange: searchProductFilter,
          options: productosOptions || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      },
      {
        key:"calidad",
        keyValue:"calidad",
        label:"Calidad o presentacion",
        component:InputWithLabel,
        responsiveSize:6,
        inputProps:{
          size:"small",
          type:"text"
        }
      },
    ]
  },

]
    } ;


   
    return (<>
    {
      isVisibleModalDetalle &&
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    schemaValidator={schema}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    />
    }
   
    <Grid container spacing={2} >


        <Grid item sm={12} xs={12} md={12} >
          <Button variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nueva producto</Button>
        </Grid>

        <Grid item sm={12} xs={12} md={4} >

          <InputWithLabel
            label="Buscar producto"

            onChange={onSearchItem}
            endAdornment={<Search />}
          />


        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={JSON.stringify(prod)}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell   >
                          {<Col.bodyRender info={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}